import { render, staticRenderFns } from "./questions-type.vue?vue&type=template&id=7d1093b1&scoped=true&"
import script from "./questions-type.vue?vue&type=script&lang=js&"
export * from "./questions-type.vue?vue&type=script&lang=js&"
import style0 from "./questions-type.vue?vue&type=style&index=0&id=7d1093b1&scoped=true&lang=less&"
import style1 from "./questions-type.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d1093b1",
  null
  
)

export default component.exports